module.exports = __webpack_public_path__ + "img/warning.e2e73a16.svg";